import { useEffect } from 'react'

export const useWindowResizeListener = (callback: (event: Event) => void) =>
	useEffect(() => {
		window.addEventListener('resize', callback)
		return () => window.removeEventListener('resize', callback)
	}, [])
